import { render, staticRenderFns } from "./jcb-agricultural.vue?vue&type=template&id=65f587df&"
import script from "./jcb-agricultural.vue?vue&type=script&lang=js&"
export * from "./jcb-agricultural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports